/**
 * 系统配置模块的接口
 * */
import base from './base' // 接口域名列表
import axios from '@/utils/http' // 导入创建的axios实例
// import axios2 from 'axios'
// import qs from 'qs' // 序列化post请求的
// import constant from '../utils/constant'

let www = base.proxy

// axios.defaults.headers.common['token'] = constant.getToken()

// 开始定义接口
const systemConfig = {
  applyStatusApi () {
    return axios.post(`${www}/wtapi/external/api/constent/applystatus`)
  },
  recruitTypeApi () {
    return axios.post(`${www}/wtapi/external/api/constent/recruitType`)
  },
  systemConfigApi () {
    return axios.post(`${www}/wtapi/external/api/config/system`)
  },
  saveConfigApi (params) {
    return axios.post(`${www}/wtapi/external/api/config/save`, JSON.parse(params), {
      header: {
        'Content-Type': 'application/json'
      }
    })
  }
}

export default systemConfig



// WEBPACK FOOTER //
// ./src/api/systemConfig.js